import {
  DTOCreateForgeProject,
  DTOCreateForgeProjectResponse,
  DTOForgeProjectGetResponse,
  DTOForgeProjectsListResponse,
  DTORemoveForgeProjectResponse,
  DTOUpdateForgeProject,
  DTOUpdateForgeProjectResponse,
} from "../../dto";
import { RequestExecutor } from "../../transport";

export class ForgeProjectsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(workspaceId: string) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}/forge/projects`, DTOForgeProjectsListResponse, {
      method: "GET",
    });
  }

  create(workspaceId: string, body: DTOCreateForgeProject) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}/forge/projects`, DTOCreateForgeProjectResponse, {
      method: "POST",
      body,
    });
  }

  get(workspaceId: string, projectId: string) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}`,
      DTOForgeProjectGetResponse,
      {
        method: "GET",
      }
    );
  }

  update(workspaceId: string, projectId: string, body: DTOUpdateForgeProject) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}`,
      DTOUpdateForgeProjectResponse,
      {
        method: "PUT",
        body,
      }
    );
  }

  delete(workspaceId: string, projectId: string) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}`,
      DTORemoveForgeProjectResponse,
      {
        method: "DELETE",
      }
    );
  }
}
